<template>
  <div :id="$options.name" class="heading">
    <div class="heading__wrap">
      <div class="heading__element heading__element--first">
        <div class="d-flex align-items-center">
          <vb-icon
            class="heading__icon heading__icon--like"
            v-if="details.rating.preferred"
            v-b-popover.hover.top="'Pensato per offrire un ottimo servizio e un buon rapporto qualità-prezzo.'"
            :name="'like'"
            :color="'f8af3c'"
            :size="18"
          />
          <div class="d-flex">
            <h1 class="heading__title">{{ details.name.it }}</h1>
            <b-form-rating
              class="heading__star"
              v-if="details.rating.stars !== 0"
              no-border inline readonly
              size="md"
              variant="secondary"
              :value="details.rating.stars"
            />
          </div>
        </div>
        <p class="heading__address">
          <vb-icon class="heading__icon mr-1" :name="'symbol_lb'" :size="14" />
          <span>
            {{ details.location.address.it + ', ' + details.location.postal_code + ' ' + details.location.city_name }}
          </span>
          <span class="heading__address-map" v-b-modal="'modal_map'">vedi mappa</span>
        </p>
      </div>
      <div class="heading__element heading__element--second">
        <score class="heading__score" :rating="details.rating.review_score" direction="row" />
        <router-link :to="{ name: 'detail', hash: '#rooms' }">
          <vb-button
            class="semibold"
            :vb_options="{
              text: 'Prenota Ora',
              variant: 'info',
              size: 'sm',
            }"
          />
        </router-link>
      </div>
    </div>
    <vb-modal
      :vb_options="{
        id: 'modal_map',
        size: 'xl',
        title: details.name.it,
        hide_footer: true,
      }"
    >
      <detail-google-map
        :map_markers="g_map.markers"
        :map_location="g_map.location"
      />
    </vb-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { map_markers_v3 } from '@bookingv3/utilities'
import Score from "@bookingv3/components/atoms/score"
import GoogleMap from '@components/blocks/map'

export default {
  inheritAttrs: false,
  name: 'heading',

  components: {
    'detail-google-map': GoogleMap,
    'score': Score,
  },

  props: {
    details: Object,
    availability: String,
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      // livebkv3
      selected_hotel: state => state.livebkv3.selected_hotel,
    }),

    g_map() {
      return {
        markers: map_markers_v3([this.selected_hotel], this.availability, this.sass),
        location: {
          ...this.details.location.coordinates
        }
      }
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .heading {

    &__wrap {
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      @include media-breakpoint-up(md){
        flex-direction: row;
        align-items: center;
      }
    }

    &__element {

      &--second {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
        margin-top: 10px;
        border-top: 1px solid $gray-300;

        @include media-breakpoint-up(md){
          display: block;
          margin-top: 0;
          padding-top: 0;
          border: none;
          text-align: right;
        }
      }
    }

    &__icon {
      &--like {
        background-color: $white;
        padding: 3px;
        border-radius: $border-radius-lg;
        margin-right: 10px;
      }
    }

    &__title {
      margin-bottom: 0;
    }

    &__star {
      margin-left: 5px;
      margin-top: -15px;
      width: auto;
    }

    &__address {
      display: flex;
      align-items: center;
      margin-bottom: 0;

      &-map {
        color: $info;
        margin-left: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    &__score {
      margin-bottom: 10px;
    }
  }

  .map {
    max-height: 80vh;
    height: 320px;
    @include media-breakpoint-up(sm) {
      height: 400px;
    }
    @include media-breakpoint-up(md) {
      height: 600px;
    }
  }

</style>